<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>控股集团官网</el-breadcrumb-item>
      <el-breadcrumb-item>线下订单</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.status" placeholder="请选择" class="select"  style="width: 200px;">
               <el-option
                 v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
               </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.addressname" @keyup.enter.native="clicksearch" placeholder="请输入收件人姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.addressphone" @keyup.enter.native="clicksearch" placeholder="请输入收件人手机号码" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" @expand-change="expandchange" ref="dataList" border stripe >
          <el-table-column type="expand" min-width="2%">
            <template slot-scope="props">
              <el-table :data="props.row.Sublist" height="200" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
                <el-table-column label="图标"  prop="Thumbnail" min-width="5%">
                  <template v-slot="scope">
                    <img :src="scope.row.Thumbnail" min-width="64" height="64" />
                  </template>
                </el-table-column>
                <el-table-column label="产品" prop="Productinfo" min-width="5%"></el-table-column>
                <el-table-column label="数量" prop="Productnum" min-width="5%"></el-table-column>
                <el-table-column label="单价" prop="Productprice" min-width="5%"></el-table-column>
                <el-table-column label="总价" prop="Productamount" min-width="5%"></el-table-column>
                <el-table-column label="物流状态" prop="StatusName" min-width="5%"></el-table-column>
                <el-table-column label="物流公司" prop="Logisticsname" min-width="5%"></el-table-column>
                <el-table-column label="物流单号" prop="Logisticsid" min-width="5%"></el-table-column>
                <el-table-column label="操作" min-width="5%">
                  <template v-slot="scope">
                    <el-button v-if="scope.row.Status <= 2" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goEdit(scope.row)">填写发货信息</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Orderid" label="订单号(点击查看详情)" min-width="15%">
            <template slot-scope="props">
              <span class="blue" style="margin-left: 0; margin-right: 5px;color: #48c9b0;font-weight:bold;" @click="toogleExpand(props.row)">{{props.row.Orderid}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Moneyproduct" label="产品金额" min-width="5%"></el-table-column>
          <el-table-column prop="Moneyyunfei" label="运费" min-width="5%"></el-table-column>
          <el-table-column prop="Moneytotal" label="合计金额" min-width="5%"></el-table-column>
          <el-table-column prop="StatusName" label="订单状态" min-width="5%"></el-table-column>
          <el-table-column prop="Addressname" label="收件人姓名" min-width="7%"></el-table-column>
          <el-table-column prop="Addressphone" label="收件人号码" min-width="7%"></el-table-column>
          <el-table-column prop="Addressinfo" label="收件地址" min-width="33%"></el-table-column>
          <el-table-column prop="InvoicetypeName" label="申请发票" min-width="7%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
<!--              <el-button v-if="scope.row.Status >= 2" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goSend(scope.row)">发货管理</el-button> -->
              <el-button v-if="scope.row.Status == 4" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goInvoice(scope.row)">发票管理</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 发货管理 -->
      <el-tab-pane label="发货管理" name="second" disabled="disabled">
        <KgjtWebsiteOfflineOrderSend ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KgjtWebsiteOfflineOrderSend>
      </el-tab-pane>
      <!-- 发货管理 -->

      <!-- 发票 -->
      <el-tab-pane label="发票" name="three" disabled="disabled">
        <KgjtWebsiteOfflineOrderInvoice ref="SubVuethree" v-on:triggerFunc="BackToFirst"></KgjtWebsiteOfflineOrderInvoice>
      </el-tab-pane>
      <!-- 发票 -->

      <!-- 填写发货信息弹出框 -->
      <el-dialog title="填写发货信息" :visible.sync="editDialog" width="30%" :close-on-click-modal="false">
        <el-form :model="editData" ref="addMechanismRef" label-width="120px">

          <el-form-item label="物流公司" class="addAdminForm">
            <el-input v-model="editData.logisticsname" placeholder="请输入物流公司"></el-input>
          </el-form-item>

          <el-form-item label="物流单号" class="addAdminForm">
            <el-input v-model="editData.logisticsid" placeholder="请输入物流单号"></el-input>
          </el-form-item>

          <el-form-item>
              <el-button type="primary" @click="clickSaveEdit">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- 填写发货信息弹出框 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import KgjtWebsiteOfflineOrderSend from '@/componentsKgjt/KgjtWebsiteOfflineOrderSend.vue'
import KgjtWebsiteOfflineOrderInvoice from '@/componentsKgjt/KgjtWebsiteOfflineOrderInvoice.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    KgjtWebsiteOfflineOrderSend,
    KgjtWebsiteOfflineOrderInvoice
  },
  name: 'MyKgjtWebsiteOfflineOrder',
  data () {
    return {
      activeName: 'first',
      statusList: [
        { value: '0', label: '请选择订单状态' },
        { value: '1', label: '待付款' },
        { value: '2', label: '待发货' },
        { value: '3', label: '已发货' },
        { value: '4', label: '已完成' },
        { value: '99', label: '已取消' }
      ],
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        status: '0',
        orderid: '',
        addressname: '',
        addressphone: ''
      },
      editDialog: false,
      editData: {
        id: '',
        orderid: '',
        logisticsid: '',
        logisticsname: ''
      }
    }
  },
  mounted () {
    this.GetKgjtWebsiteOfflineOrderNum()
    this.GetKgjtWebsiteOfflineOrderList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.GetKgjtWebsiteOfflineOrderList()
    },
    // 填写发货信息
    goEdit (row) {
      this.editData.id = row.Id
      this.editData.orderid = row.Orderid
      this.editData.logisticsid = row.Logisticsid
      this.editData.logisticsname = row.Logisticsname
      this.editDialog = true
      console.log(row)
    },
    // 发货管理
    goSend (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 发票管理
    goInvoice (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData(row)
    },
    expandchange (row, expanded) {
    },
    toogleExpand (row) {
      const $table = this.$refs.dataList
      this.dataList.map((item) => {
        if (row.Orderid !== item.Orderid) {
          $table.toggleRowExpansion(item, false)
        }
      })
      $table.toggleRowExpansion(row)
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteOfflineOrderList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.GetKgjtWebsiteOfflineOrderNum()
      this.GetKgjtWebsiteOfflineOrderList()
    },
    clickadd () {
      this.AddKgjtWebsiteErpProduct()
    },
    clickSaveEdit () {
      this.EditKgjtWebsiteOfflineOrderSubStatus()
    },
    GetKgjtWebsiteOfflineOrderList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        status: that.keywords.status,
        orderid: that.keywords.orderid,
        addressname: that.keywords.addressname,
        addressphone: that.keywords.addressphone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteOfflineOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteOfflineOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        status: that.keywords.status,
        orderid: that.keywords.orderid,
        addressname: that.keywords.addressname,
        addressphone: that.keywords.addressphone
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteOfflineOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    EditKgjtWebsiteOfflineOrderSubStatus: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editData.id,
        orderid: that.editData.orderid,
        logisticsid: that.editData.logisticsid,
        logisticsname: that.editData.logisticsname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteOfflineOrderSubStatus, Qs.stringify(data))
        .then(function (response) {
          that.editDialog = false
          that.GetKgjtWebsiteOfflineOrderList()
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
